/* eslint-disable */
import requestRawDev from '@/utils/requestRawDev'
import { APICore } from '@/utils/servicesApi'

export function GetAccount() {
    return requestRawDev({
        url: APICore() + '/binance/account',
        method: 'get',
        // data: data // untuk array data post
    })
}
export function ListOpenOrders(symbol) {
    return requestRawDev({
        url: APICore() + '/binance/list-open-orders?symbol=' + symbol,
        method: 'get',
        // data: data // untuk array data post
    })
}

export function ListOrders(data) {
    return requestRawDev({
        url: APICore() + '/binance/list-orders',
        method: 'post',
        data: data // untuk array data post
    })
}


export function CreateOrders(data) {
    return requestRawDev({
        url: APICore() + '/binance/create-order',
        method: 'post',
        data: data // untuk array data post
    })
}


// WEBPACK FOOTER //
// ./src/api/binance.js